import styled from "styled-components";
import Block, { BlockContent } from "~/components/Block";
import { getCommonSliceProps } from "~/external/prismic";
import connectSlice from "~/lib/connectSlice";

const PlayerWrapper = styled.div<any>`
  max-width: 100%;
  text-align: ${(p) => p.alignment};
  iframe {
    max-width: 100%;
  }
`;

function SoundCloudPlayer(props) {
  const {
    spacingTop = 0,
    spacingBottom = 6,

    backgroundColor,
    color,
    highlightColor,

    url,
    height,
    alignment,
    ignoreHeight,
  } = props;

  if (!url) return null;

  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContent>
        <PlayerWrapper alignment={alignment}>
          <iframe
            width={ignoreHeight ? "100%" : `${height}px`}
            height={ignoreHeight ? "150px" : `${height}px`}
            src={url}
            frameBorder="no"
            scrolling="no"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </PlayerWrapper>
      </BlockContent>
    </Block>
  );
}

export function mapSliceToProps(slice) {
  const { primary, items = [] } = slice;

  let url = null;
  let isPlaylist = false;

  if (primary.link) {
    try {
      isPlaylist = primary.link.url.indexOf("/sets/") !== -1;
      url = `https://w.soundcloud.com/player/?url=${encodeURIComponent(
        primary.link.url
      )}&color=${encodeURIComponent(
        primary.color ?? "#cbff0f"
      )}&auto_play=${encodeURIComponent(
        primary.enable_automatic_play
      )}&hide_related=${encodeURIComponent(
        primary.show_soundcloud_overlays
      )}&show_comments=${encodeURIComponent(
        primary.show_comments
      )}&show_user=${encodeURIComponent(
        primary.show_display_names
      )}&show_reposts=false&show_teaser=true&visual=${encodeURIComponent(
        primary.enable_visual_style
      )}`;
    } catch (err) {
      console.error("Failed to set URL", err);
    }
  }

  const props = {
    ...getCommonSliceProps(slice),
    url,
    isPlaylist,
    ignoreHeight: !primary.enable_visual_style && !isPlaylist,
    height: primary.height,
    alignment: primary.alignment,
  };

  return props;
}

export default connectSlice(mapSliceToProps)(SoundCloudPlayer);
